/** @format */

import Base from "@/api-services/base";
const BaseURL = `Mantenimiento`;

export default {
  GetsResponse: null,
  Listado: [],
  FotoURL(Registro) {
    return "/img/grupos.svg";
  },

  getsVistasMetricasSaaSExcel(Vista, BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado) {
    return this.getsVistasExcel(Vista, "vMetricasSaaS", BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado);
  },
  
  /*
-- =============================================
-- Vista: vMetricasSaaS
-- Descripción: Obtiene todas las métricas clave para evaluar el crecimiento
--              de la startup startup SaaS a nivel de suscripciones y grupos empresariales.
--              Del mes anterior al día de hoy hacia atras.
--
--
-- Regresa una propiedad listado con todos los registros que contienen las siguientes columnas:
--
-- DOCUMENTACIÓN DE CAMPOS:
-- 
-- === CAMPOS DE IDENTIFICACIÓN ===
-- MesPeriodo: Fecha del primer día del mes del período (DATETIME)
-- Periodo: Período en formato YYYY-MM (VARCHAR)
-- PeriodoTexto: Período en formato texto legible (ej: "Enero 2024") (VARCHAR)
--
-- === MÉTRICAS DE SUSCRIPCIONES ===
-- SuscripcionesInicioMes: Número de suscripciones activas al inicio del mes (INT)
-- SuscripcionesNuevas: Nuevas suscripciones adquiridas durante el mes (INT)
-- SuscripcionesChurn: Suscripciones que abandonaron durante el mes (INT)
-- SuscripcionesFinMes: Número total de suscripciones activas al final del mes (INT)
-- SuscripcionesRetenidas: Suscripciones que continuaron sin cambios en MRR (INT)
-- SuscripcionesExpansion: Suscripciones que aumentaron su MRR (upgrade) (INT)
-- SuscripcionesContraccion: Suscripciones que redujeron su MRR (downgrade) (INT)
-- CrecimientoNetoSuscripciones: Nuevas suscripciones menos churn (INT)
--
-- === MÉTRICAS DE USUARIOS ===
-- UsuariosInicioMes: Total de usuarios licenciados al inicio del mes (INT)
-- UsuariosNuevos: Usuarios de suscripciones nuevas (INT)
-- UsuariosChurn: Usuarios perdidos por cancelación de suscripciones (INT)
-- UsuariosExpansion: Usuarios adicionales por expansión en suscripciones existentes (INT)
-- UsuariosContraccion: Usuarios reducidos por contracción en suscripciones existentes (INT)
-- UsuariosFinMes: Total de usuarios licenciados al final del mes (INT)
-- CrecimientoNetoUsuarios: Cambio neto en usuarios (nuevos+expansión-churn-contracción) (INT)
--
-- === MÉTRICAS DE MRR (Monthly Recurring Revenue) ===
-- MRRInicioMes: Ingresos recurrentes mensuales al inicio del período (DECIMAL 18,2)
-- NewMRR: MRR de suscripciones nuevas adquiridas en el mes (DECIMAL 18,2)
-- ExpansionMRR: MRR adicional por upgrades en suscripciones existentes (DECIMAL 18,2)
-- ContractionMRR: MRR reducido por downgrades en suscripciones existentes (DECIMAL 18,2)
-- ChurnedMRR: MRR perdido por cancelaciones de suscripciones (DECIMAL 18,2)
-- MRRFinMes: Ingresos recurrentes mensuales al final del período (DECIMAL 18,2)
-- NetNewMRR: Cambio neto en MRR (New+Expansion-Contraction-Churn) (DECIMAL 18,2)
--
-- === INGRESOS NO RECURRENTES ===
-- IngresosActivacion: Cargos únicos por activación/implementación (DECIMAL 18,2)
-- OtrosIngresos: Otros ingresos no recurrentes (DECIMAL 18,2)
-- IngresoTotalMes: Suma de MRR más ingresos no recurrentes (DECIMAL 18,2)
--
-- === TASAS Y RATIOS ===
-- TasaChurnClientes: % de suscripciones que abandonaron (Logo Churn Rate) (DECIMAL 5,2)
-- TasaRetencionClientes: % de suscripciones retenidas (DECIMAL 5,2)
-- TasaChurnMRRBruto: % de MRR perdido solo por cancelaciones (DECIMAL 5,2)
-- TasaChurnMRRNeto: % de MRR perdido por cancelaciones + contracciones (DECIMAL 5,2)
-- NetRevenueRetention (NRR): % de MRR retenido incluyendo expansiones (DECIMAL 5,2)
-- GrossRevenueRetention (GRR): % de MRR retenido sin incluir expansiones (DECIMAL 5,2)
-- TasaCrecimientoMRRMoM: % de crecimiento MRR mes sobre mes (DECIMAL 5,2)
-- ARPUFinMes: Ingreso promedio por usuario (MRR/Usuarios) (DECIMAL 18,2)
-- ARPAFinMes: Ingreso promedio por suscripción (MRR/Suscripciones) (DECIMAL 18,2)
-- QuickRatioSaaS: (New+Expansion)/(Churn+Contraction) - Indicador de salud (DECIMAL 5,2)
--
-- === MÉTRICAS DE GRUPOS EMPRESARIALES (NUEVAS) ===
-- GruposInicioMes: Número de grupos empresariales activos al inicio del mes (INT)
-- GruposNuevos: Nuevos grupos empresariales adquiridos durante el mes (INT)
-- GruposChurn: Grupos empresariales que abandonaron completamente durante el mes (INT)
-- GruposFinMes: Número total de grupos empresariales activos al final del mes (INT)
-- CrecimientoNetoGrupos: Nuevos grupos menos churn de grupos (INT)
-- TasaChurnGrupos: % de grupos que abandonaron (DECIMAL 5,2)
-- TasaRetencionGrupos: % de grupos retenidos (DECIMAL 5,2)
-- MRRPromedioGrupo: MRR promedio por grupo empresarial (DECIMAL 18,2)
-- UsuariosPromedioGrupo: Número promedio de usuarios por grupo (DECIMAL 10,2)
-- SuscripcionesPromedioGrupo: Número promedio de suscripciones por grupo (DECIMAL 10,2)
--
-- Fecha Creación: 2024-12-09
-- Fecha Actualización: 2024-12-12
-- =============================================*/
  getsVistasMetricasSaaS(Vista, BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado) {
    return this.getsVistas(Vista, "vMetricasSaaS", BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado);
  },

/*
-- =============================================
-- Vista: vMetricasSaaSUSD
-- Descripción: Obtiene todas las métricas clave para evaluar el crecimiento
--              de la startup SaaS a nivel de suscripciones y grupos empresariales.
--              Del mes anterior al día de hoy hacia atrás.
--              NOTA: Todos los valores monetarios están expresados en USD.
--
-- Regresa una propiedad listado con todos los registros que contienen las siguientes columnas:
--
-- DOCUMENTACIÓN DE CAMPOS:
-- 
-- === CAMPOS DE IDENTIFICACIÓN ===
-- MesPeriodo: Fecha del primer día del mes del período (DATETIME)
-- Periodo: Período en formato YYYY-MM (VARCHAR)
-- PeriodoTexto: Período en formato texto legible (ej: "Enero 2024") (VARCHAR)
--
-- === MÉTRICAS DE SUSCRIPCIONES ===
-- SuscripcionesInicioMes: Número de suscripciones activas al inicio del mes (INT)
-- SuscripcionesNuevas: Nuevas suscripciones adquiridas durante el mes (INT)
-- SuscripcionesChurn: Suscripciones que abandonaron durante el mes (INT)
-- SuscripcionesFinMes: Número total de suscripciones activas al final del mes (INT)
-- SuscripcionesRetenidas: Suscripciones que continuaron sin cambios en MRR (INT)
-- SuscripcionesExpansion: Suscripciones que aumentaron su MRR (upgrade) (INT)
-- SuscripcionesContraccion: Suscripciones que redujeron su MRR (downgrade) (INT)
-- CrecimientoNetoSuscripciones: Nuevas suscripciones menos churn (INT)
--
-- === MÉTRICAS DE USUARIOS ===
-- UsuariosInicioMes: Total de usuarios licenciados al inicio del mes (INT)
-- UsuariosNuevos: Usuarios de suscripciones nuevas (INT)
-- UsuariosChurn: Usuarios perdidos por cancelación de suscripciones (INT)
-- UsuariosExpansion: Usuarios adicionales por expansión en suscripciones existentes (INT)
-- UsuariosContraccion: Usuarios reducidos por contracción en suscripciones existentes (INT)
-- UsuariosFinMes: Total de usuarios licenciados al final del mes (INT)
-- CrecimientoNetoUsuarios: Cambio neto en usuarios (nuevos+expansión-churn-contracción) (INT)
--
-- === MÉTRICAS DE MRR (Monthly Recurring Revenue) EN USD ===
-- MRRInicioMes: Ingresos recurrentes mensuales al inicio del período en USD (DECIMAL 18,2)
-- NewMRR: MRR de suscripciones nuevas adquiridas en el mes en USD (DECIMAL 18,2)
-- ExpansionMRR: MRR adicional por upgrades en suscripciones existentes en USD (DECIMAL 18,2)
-- ContractionMRR: MRR reducido por downgrades en suscripciones existentes en USD (DECIMAL 18,2)
-- ChurnedMRR: MRR perdido por cancelaciones de suscripciones en USD (DECIMAL 18,2)
-- MRRFinMes: Ingresos recurrentes mensuales al final del período en USD (DECIMAL 18,2)
-- NetNewMRR: Cambio neto en MRR (New+Expansion-Contraction-Churn) en USD (DECIMAL 18,2)
--
-- === INGRESOS NO RECURRENTES EN USD ===
-- IngresosActivacion: Cargos únicos por activación/implementación en USD (DECIMAL 18,2)
-- OtrosIngresos: Otros ingresos no recurrentes en USD (DECIMAL 18,2)
-- IngresoTotalMes: Suma de MRR más ingresos no recurrentes en USD (DECIMAL 18,2)
--
-- === TASAS Y RATIOS ===
-- TasaChurnClientes: % de suscripciones que abandonaron (Logo Churn Rate) (DECIMAL 5,2)
-- TasaRetencionClientes: % de suscripciones retenidas (DECIMAL 5,2)
-- TasaChurnMRRBruto: % de MRR perdido solo por cancelaciones (DECIMAL 5,2)
-- TasaChurnMRRNeto: % de MRR perdido por cancelaciones + contracciones (DECIMAL 5,2)
-- NetRevenueRetention (NRR): % de MRR retenido incluyendo expansiones (DECIMAL 5,2)
-- GrossRevenueRetention (GRR): % de MRR retenido sin incluir expansiones (DECIMAL 5,2)
-- TasaCrecimientoMRRMoM: % de crecimiento MRR mes sobre mes (DECIMAL 5,2)
-- ARPUFinMes: Ingreso promedio por usuario (MRR/Usuarios) en USD (DECIMAL 18,2)
-- ARPAFinMes: Ingreso promedio por suscripción (MRR/Suscripciones) en USD (DECIMAL 18,2)
-- QuickRatioSaaS: (New+Expansion)/(Churn+Contraction) - Indicador de salud (DECIMAL 5,2)
--
-- === MÉTRICAS DE GRUPOS EMPRESARIALES ===
-- GruposInicioMes: Número de grupos empresariales activos al inicio del mes (INT)
-- GruposNuevos: Nuevos grupos empresariales adquiridos durante el mes (INT)
-- GruposChurn: Grupos empresariales que abandonaron completamente durante el mes (INT)
-- GruposFinMes: Número total de grupos empresariales activos al final del mes (INT)
-- CrecimientoNetoGrupos: Nuevos grupos menos churn de grupos (INT)
-- TasaChurnGrupos: % de grupos que abandonaron (DECIMAL 5,2)
-- TasaRetencionGrupos: % de grupos retenidos (DECIMAL 5,2)
-- MRRPromedioGrupo: MRR promedio por grupo empresarial en USD (DECIMAL 18,2)
-- UsuariosPromedioGrupo: Número promedio de usuarios por grupo (DECIMAL 10,2)
-- SuscripcionesPromedioGrupo: Número promedio de suscripciones por grupo (DECIMAL 10,2)
--
-- === TIPO DE CAMBIO ===
-- TipoCambioPromedioUSDMXN: Tipo de cambio promedio USD/MXN utilizado en el período (DECIMAL 10,4)
--
-- Fecha Creación: 2024-12-13
-- =============================================*/
  getsVistasMetricasSaaSUSD(Vista, BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado) {
    return this.getsVistas(Vista, "vMetricasSaaSUSD", BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado);
  },

  getsVistasMetricasSaaSUSDExcel(Vista, BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado) {
    return this.getsVistasExcel(Vista, "vMetricasSaaSUSD", BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado);
  },

  getsVistas(Vista, TablaOVista, BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.get(
      Vista,
      `${Base.URL}/${BaseURL}/Vistas/${TablaOVista}`,
      { params: BaseGetsListado },
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  getsVistasExcel(Vista, TablaOVista, BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado) {
    if (OnCorrecto == null) {
      OnCorrecto = (response) => {
        Base.Response2FileDownload(response);
      };
    }

    return Base.get(
      Vista,
      `${Base.URL}/${BaseURL}/Vistas/${TablaOVista}/Excel`,
      {
        responseType: "blob",
        params: BaseGetsListado,
      },
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  gets(Vista, BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(Vista, BaseURL, BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado);
  },
  getsSelect(Vista, OnCorrecto, OnErroneo, OnFinalizado) {
    if (this.GetsResponse != null) OnCorrecto(this.GetsResponse);
    return Base.getsBaseSuscripcion(
      Vista,
      BaseURL,
      { PaginaLen: 1000 },
      (response) => {
        this.GetsResponse = response;
        this.Listado = response.data.listado;
        if (OnCorrecto != undefined) OnCorrecto(response);
      },
      OnErroneo,
      OnFinalizado
    );
  },
  put(Vista, ID, Datos, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/${ID}`);
    return Base.put(Vista, URL, Datos, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },
  post(Vista, Datos, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.postBaseSuscripcion(Vista, BaseURL, Datos, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },
  get(Vista, id, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(Vista, `${BaseURL}/${id}`, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },
  delete(Vista, id, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.deleteBaseSuscripcion(Vista, `${BaseURL}/${id}`, OnCorrecto, OnErroneo, OnFinalizado);
  },
  Version(Vista, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.get(Vista, `${Base.URL}/${BaseURL}/Version`, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },

  /**
   * Obtiene los tipos de cambio registrados
   * 
   * @param {Object} Params - Parámetros de consulta
   * @param {string} Params.FechaInicio - Fecha de inicio (opcional) formato: string($date-time)
   * @param {string} Params.FechaFin - Fecha de fin (opcional) formato: string($date-time)
   * @param {string} Params.MonedaOrigen - Moneda de origen (por defecto USD)
   * @param {string} Params.MonedaDestino - Moneda de destino (por defecto MXN)
   * 
   * @returns {Array} Lista de tipos de cambio con la siguiente estructura:
   * {
   *   "creado": "2025-12-13T23:02:14.129Z",
   *   "actualizadoD": "2025-12-13T23:02:14.129Z",
   *   "borrado": true,
   *   "id": "string",
   *   "fecha": "2025-12-13",
   *   "monedaOrigen": "USD",
   *   "monedaDestino": "MXN",
   *   "tasa": 17.2345
   * }
   */
  getsTiposCambio(Vista, Params, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.get(
      Vista,
      `${Base.URL}/${BaseURL}/TiposCambio`,
      {
        params: Params,
      },
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
};
